import React, { useState } from 'react';
import {ThemedText, ThemedView} from "@app/theme";
import CheckBox from "@sharedComponents/CheckBox/CheckBox";
import InfoIcon from "../../../../assets/Icons/InfoIcon";
import {TouchableOpacity} from "react-native";
import {RadioButton} from "@phosphor-icons/react";
import SelectedRadioButton from "../../../../assets/Icons/SelectedRadioButton";
import UnSelectedRadioButton from "../../../../assets/Icons/UnSelectedRadioButton";
import DelhiToolTip from "@screens/StateSelection/components/DelhiToolTip";
import GujaratToolTip from "@screens/StateSelection/components/GujaratToolTip";
import TamilNaduToolTip from "@screens/StateSelection/components/TamilToolTip";

interface IndividualStateCardProps {
    title: string;
    stampDutyAmount: string;
    setSelectedState: (selectedState: string) => void;
    selected: boolean;
    setShowStampDutyToolTip: (showStampDutyToolTip: boolean) =>  void;
    setShowTamilNaduToolTip?: (show: boolean) => void;
    setShowDelhiToolTip?: (show: boolean) => void;
    setShowGujaratToolTip?: (show: boolean) => void;
    activeTooltip: string | null;
    setActiveTooltip: (tooltip: string | null) => void;
}

export const IndividualStateCard: React.FC<IndividualStateCardProps> = ({
    title,
    stampDutyAmount,
    setSelectedState,
    selected,
    setShowStampDutyToolTip,
    setShowTamilNaduToolTip,
    setShowDelhiToolTip,
    setShowGujaratToolTip,
    activeTooltip,
    setActiveTooltip
}) => {
    const isTooltipVisible = activeTooltip === title;

    const handleTooltipPress = () => {
        if (isTooltipVisible) {
            // If current tooltip is visible, close it
            setActiveTooltip(null);
        } else {
            // If current tooltip is not visible, close any other tooltip and open this one
            setActiveTooltip(title);
        }
    };

    return (
        <TouchableOpacity style={{ zIndex: isTooltipVisible ? 10000 : 1 }} activeOpacity={1} onPress={() => {
            setSelectedState(title);
            setActiveTooltip(null);
        }}>
            <ThemedView flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"} padding={"md"} mb={"md"}
                        alignContent={"center"} borderRadius={"sm"} borderWidth={1} borderColor={selected ? "border-action": "border-secondary"}  backgroundColor={selected ? "bg-fill-emphasis-primary-1" : "white"}
            >
                <ThemedView flexDirection={"row"} alignItems={"center"}>
                    {selected ? <SelectedRadioButton /> : <UnSelectedRadioButton />}
                    <ThemedView ml={"sm"}>
                        <ThemedText variant={"b4r"} color={"text-secondary"}>
                            {title}
                        </ThemedText>
                        <ThemedText variant={"b3s"} color={"text-primary"}>
                            {`₹${stampDutyAmount}`}
                        </ThemedText>
                    </ThemedView>
                </ThemedView>
                <ThemedView flexDirection={"row"} alignItems={"center"}>
                    <ThemedText variant={"b4r"} color={"text-secondary"} mr={"2xs"}>
                        See how
                    </ThemedText>
                    <TouchableOpacity 
                        style={{ position: 'relative' }} 
                        activeOpacity={1} 
                        onPress={(e) => {
                            e.stopPropagation();
                            handleTooltipPress();
                        }}
                    >
                        <InfoIcon size={14} fill={"#80838D"}/>
                        {isTooltipVisible && title === "Delhi" && (
                            <DelhiToolTip 
                                onClose={() => setActiveTooltip(null)} 
                                delhiStamptyAmount={"200"} 
                            />
                        )}
                        {isTooltipVisible && title === "Gujarat" && (
                            <GujaratToolTip onClose={() => setActiveTooltip(null)} />
                        )}
                        {isTooltipVisible && title === "Tamil Nadu" && (
                            <TamilNaduToolTip onClose={() => setActiveTooltip(null)} />
                        )}
                    </TouchableOpacity>
                </ThemedView>

            </ThemedView>
        </TouchableOpacity>

    );
};